import { useState, useEffect } from 'react';
import { Seguro, CreateSeguroDto } from '../types/seguro';
import { fetchSeguros, createSeguro, updateSeguro, deleteSeguro } from '../services/segurosService';
import { toast } from 'react-hot-toast';

export const useSeguros = () => {
  const [seguros, setSeguros] = useState<Seguro[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const loadSeguros = async () => {
    try {
      setLoading(true);
      const data = await fetchSeguros();
      setSeguros(data);
      setError(null);
    } catch (err) {
      setError('Error al cargar seguros');
      toast.error('Error al cargar seguros');
    } finally {
      setLoading(false);
    }
  };

  const addSeguro = async (seguro: CreateSeguroDto) => {
    try {
      const nuevoSeguro = await createSeguro(seguro);
      setSeguros([...seguros, nuevoSeguro]);
      toast.success('Seguro creado exitosamente');
      return nuevoSeguro;
    } catch (err) {
      toast.error('Error al crear seguro');
      throw err;
    }
  };

  const editSeguro = async (id: string, seguro: Partial<CreateSeguroDto>) => {
    try {
      const seguroActualizado = await updateSeguro(id, seguro);
      setSeguros(seguros.map(s => s._id === id ? seguroActualizado : s));
      toast.success('Seguro actualizado exitosamente');
      return seguroActualizado;
    } catch (err) {
      toast.error('Error al actualizar seguro');
      throw err;
    }
  };

  const removeSeguro = async (id: string) => {
    try {
      await deleteSeguro(id);
      setSeguros(seguros.filter(s => s._id !== id));
      toast.success('Seguro eliminado exitosamente');
    } catch (err) {
      toast.error('Error al eliminar seguro');
      throw err;
    }
  };

  useEffect(() => {
    loadSeguros();
  }, []);

  return {
    seguros,
    loading,
    error,
    addSeguro,
    editSeguro,
    removeSeguro,
    loadSeguros
  };
};